export default __webpack_public_path__ + "static/Me Edited w Shadow-61de56afc6f7be785eb5a91d164c4c34.png";